import { Component, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CountriesCodesService } from './countries-codes.service';
import { SignupSteps } from './SignupSteps.enum';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ColorPickerModule } from 'ngx-color-picker';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule,HttpClientModule,TranslateModule,NgbDropdownModule,ColorPickerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  // @ts-ignore
  @ViewChild('academyNameInputRef') public academyNameInputRef: ElementRef;

  // @ts-ignore
  @ViewChild('countryAutoCompleteRef') public countryAutoCompleteRef: ElementRef;

  complete = false;
  responseErrorMessage:boolean = false;
  progress = 0;
  SignupSteps = SignupSteps;
  currentStep = this.SignupSteps.EMAIL_AND_MOBILE; 
  logo = 'assets/img/svg/upload.svg';
  serverErrors: any = {
    mobile: [],
    email: [],
    logo: [],
    title: []
  };
  hasMobileError = false;
  hasLogoError = false;
  hasEmailError = false;
  hasTitleError = false;
  hasAlreadyRegisteredError = false;
  showCodeErrorMsg = false;
  countries = [];
  viewedCountries: any[] = [];
  selectedCountry = {
    name: 'Saudi Arabia',
    flag: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg',
    number: '+966'
  };
  form = this.fb.group({
    full_name: ['', [Validators.required]],
    // password: ['', [Validators.required]],
    // password_confirm: ['', [Validators.required]],
    email: ['', [Validators.compose([Validators.required, Validators.email])]],
    mobile: ['', [Validators.required]],
    entity_name: ['', [Validators.required]],
    entity_size: ['', [Validators.required]],
    target_size: ['', [Validators.required]],
    referred_by: ['', [Validators.required]],
    academy_target: ['', [Validators.required]],
    academy_url: ['', [Validators.required]],
    title: ['', [Validators.required]],
    logo: ['']
  },
  // { validator: this.passwordMatchValidator }
);
primaryColor = '#448AFF';
secondaryColor = '#FFC107';
textColor = '#000000';

  isLoading = false;
  destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private translateService: TranslateService,
    private countriesCodesService: CountriesCodesService
  ) {
  }
it(): void {

    this.countriesCodesService.loadCountries().pipe(
      takeUntil(this.destroy$)
    ).subscribe((countries: any) => {
      this.countries = countries;
      this.viewedCountries = countries;
    });
  }

  onOpenDropDown(): void {
    setTimeout(() => {
      this.countryAutoCompleteRef?.nativeElement?.focus();
    }, 0);
  }

  onSelectCountry(country: any): void {
    this.selectedCountry.name = country.name;
    this.selectedCountry.flag = country.flag;
    this.selectedCountry.number = country.number;
  }

  onTypeCountryNameOrNumber(event: any): void {
    const e = event.target.value;
    this.viewedCountries = [];
    this.countries.map((country: any) => {
      if (country.name.toString().toLowerCase().indexOf(e) > -1 || country.number.toString().indexOf(e) > -1) {
        this.viewedCountries.push(country);
      }
    });
  }

  nextStep(): void {
    switch (this.currentStep) {


      case this.SignupSteps.EMAIL_AND_MOBILE: {
        if (this.form.get('email')?.valid && this.form.get('mobile')?.valid && this.form.get('full_name')?.valid ) {

          this.isLoading = true;
          this.currentStep++;
          this.progress += 33;
        
        }
        break;
      }
      case SignupSteps.REACH_US: {
        if (this.form.get('academy_target')?.valid && this.form.get('referred_by')?.valid) {
          this.currentStep++;
          setTimeout(() => {
            this.academyNameInputRef?.nativeElement?.focus();
          }, 200);
          this.progress += 33;
        }
        break;
      }
      case SignupSteps.ACADEMY_INFO: {
        Object.keys(this.form.controls).forEach(key => {
          const control = this.form.get(key);
          console.log(`Control: ${key}, Status: ${control?.status}, Errors:`, control?.errors);
        });
        if (this.form.valid) {
          this.progress += (33);
          this.createAcademy();
        }
        /**
         * @TODO: needs a review
         */

        if (!this.form.get('title')?.valid) {
          this.hasTitleError = true;
          this.serverErrors.title = [this.translateService.instant('signup.INVALID_LOGO')];
        } else {
          this.hasTitleError = false;
        }
        break;
      }
    }
  }

  previousStep(): void {
    this.currentStep--;
    this.progress -= 33;
  }

  createAcademy(): void {

    this.hasMobileError = false;
    this.hasLogoError = false;
    this.hasEmailError = false;
    this.hasTitleError = false;
    this.hasAlreadyRegisteredError = false;
    const data = this.form.value;
    const formData = this.createFormData(data);
    this.isLoading = true;
    this.http.post(`/product/customer/self_register/`, formData).subscribe(() => {
      this.isLoading = false;
      this.complete = true;
      this.currentStep++;
    }, error => {
      console.log('error', error);
      this.responseErrorMessage = error.error.message
      this.isLoading = false;
      const errors = error.error;
      if (error.error.mobile && error.error.mobile.length > 0) {
        this.hasMobileError = true;
      }
     else if (error.error.title && error.error.title.length > 0) {
        this.hasTitleError = true;
      } else if (error.error.email && error.error.email.length > 0) {
        this.hasEmailError = true;
      } else if (error.error.errors && error.error.errors.length > 0) {
        this.hasAlreadyRegisteredError = true;
      }
      console.warn(error);
    }, () => {
      console.log('complete');
    });
  }

  logoInputChange($event: any): void {
    const file = $event.target.files[0];
    const reader = new FileReader();
    if (file) {
      reader.onload = (e: any) => {
        this.logo = e.target.result;
      };
      reader.readAsDataURL($event.target.files[0]);
      this.form.patchValue({logo: file});
    }
  }

  private createFormData(data: any): any {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("name", data.full_name);
    formData.append("mobile", `${this.selectedCountry.number}${data.mobile}`);
    formData.append("email", data.email);
    // formData.append("password", data.password); // Uncomment if you need to include the password
    formData.append("institution_name", data.entity_name);
    formData.append("institution_size", data.entity_size);
    formData.append("number_of_targeted_trainees", data.target_size);
    formData.append("server_url", data.academy_url);
    formData.append("way_of_reach", data.referred_by);
    formData.append("academy_use_case", data.academy_target);

    if (data.logo) {
      formData.append("logo", data.logo);  
    }
    
    // Convert color_schema object to a JSON string and append it
    formData.append(
      "color_schema",
      JSON.stringify({
        primaryColor: this.primaryColor,
        secondaryColor: this.secondaryColor,
        textColor: this.textColor,
      })
    );
    
    return formData;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

  }
}
